import { render, staticRenderFns } from "./VlTextfield.vue?vue&type=template&id=533ce02f&"
import script from "./VlTextfield.vue?vue&type=script&lang=js&"
export * from "./VlTextfield.vue?vue&type=script&lang=js&"
import style0 from "./VlTextfield.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports